import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import TickLogo from '../../static/icons/blue-tick.png';
const { REACT_APP_MY_LOBBY_BACKEND_URL } = process.env;

export const CancelBooking = (props) => {
  const [reservation, setReservation] = useState();
  const [cancelBooking, setCancelBooking] = useState(undefined);
  const { bookingId } = useParams();
  const fetchBooking = async () => {
    const { data } = await axios.get(`${REACT_APP_MY_LOBBY_BACKEND_URL}/api/rooms_reservations/view/${bookingId}`);
    return data.reservation;
  };

  const cancelBookingFunc = async () => {
    const { data } = await axios.post(`${REACT_APP_MY_LOBBY_BACKEND_URL}/api/rooms_reservations/cancelBooking/${bookingId}`);
    return data.reservation;
  };

  useEffect(() => {
    props.hideLoader();
    if (reservation === undefined) {
      const res = fetchBooking();
      res.then((r) => setReservation(r));
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (cancelBooking === true) {
      const res = cancelBookingFunc();
      res.then((r) => null);
    }
  }, [cancelBooking]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="container max-w-xs mx-auto">
      <div className="full-window columns-1 align-top px-8 pt-6 pd-8 mb-4">
        {cancelBooking === undefined ? (
          <div>
            <div className="w-full h-16 mt-5 border-2 border-black text-black text-center font-bold text-xl">
              Cancel
              <br />
              Confirmation
            </div>
            <div className="w-full h-12 mt-8 text-black text-left text-sm">
              Hey {reservation?.name}, I understand you want to <b>cancel</b> your booking for
            </div>
            <div className="mx-auto mt-12 text-black text-center text-lg font-bold">{reservation?.roomName}</div>
            <div className="w-full text-black mt-8 text-left text-sm">
              From: {new Date(reservation?.bookedTimeIn).toString()}
              <br />
              To: {new Date(reservation?.bookedTimeOut).toString()}
            </div>
            <div className="w-full mt-4 text-black text-sm text-left">
              Where: {reservation?.siteName}
              <br />
              Room: {reservation?.roomName},
            </div>
            <div className="w-full mt-8 text-black text-sm text-left">Confirmation Code: {reservation?.code}</div>
            <div className="w-full flex flex justify-around mt-16">
              <div className="grid grid-cols-1">
                <button
                  onClick={() => {
                    setCancelBooking(true);
                  }}
                  className="w-20 h-12 bg-blue-500 rounded-full"
                >
                  Yes
                </button>
              </div>
              <div className="grid grid-cols-1">
                <button
                  onClick={() => {
                    setCancelBooking(false);
                  }}
                  className="w-20 h-12 bg-blue-500 rounded-full"
                >
                  No
                </button>
              </div>
            </div>
          </div>
        ) : null}
        {cancelBooking === true ? (
          <div>
            <div className="w-full mt-16 text-black text-xl font-bold text-center">All done. Your event has been cancelled.</div>
            <div className="w-full mt-12 text-black text-lg text-left">
              We will also be sending an email to all the attendees to let them know that the meeting has been cancelled.
            </div>
            <div className="grid-rows-1 mt-20 flex justify-center">
              <img className="w-30 h-30 object-center" src={TickLogo} alt="confirm" />
            </div>
          </div>
        ) : null}
        {cancelBooking === false ? (
          <div>
            <div className="w-full mt-16 text-black text-xl font-bold text-center tracking-wide">We are not cancelling your event.</div>
            <div className="w-full mt-12 text-black text-lg text-left">Your reservation is still in effect as per the details below.</div>
            <div className="mx-auto mt-12 text-black text-center text-lg font-bold">{reservation?.roomName}</div>
            <div className="w-full text-black mt-8 text-left text-sm">
              From: {new Date(reservation?.bookedTimeIn).toString()}
              <br />
              To: {new Date(reservation?.bookedTimeOut).toString()}
            </div>
            <div className="w-full mt-4 text-black text-sm text-left">
              Where: {reservation?.siteName}
              <br />
              Room: {reservation?.roomName},
            </div>
            <div className="w-full mt-8 text-black text-sm text-left">Confirmation Code: EV 000-002</div>
          </div>
        ) : null}
      </div>
      <p className="text-center text-black text-xs">Powered by MyLobby.co</p>
    </div>
  );
};
